(function () {
  const root = document.documentElement;
  const btn  = document.getElementById('theme-toggle');

  // Load saved preference, or detect OS setting
  const saved      = localStorage.getItem('theme');
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const initial    = saved || (prefersDark ? 'dark' : 'light');

  applyTheme(initial);

  btn?.addEventListener('click', function () {
    const current = root.getAttribute('data-theme');
    applyTheme(current === 'dark' ? 'light' : 'dark');
  });

  function applyTheme(mode) {
    root.setAttribute('data-theme', mode);
    localStorage.setItem('theme', mode);

    var moon = document.querySelector('.icon-moon');
    var sun  = document.querySelector('.icon-sun');

    if (moon) moon.style.display = mode === 'dark'  ? 'block' : 'none';
    if (sun)  sun.style.display  = mode === 'light' ? 'block' : 'none';
  }
})();